import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=51911d09&scoped=true&lang=pug&"
import script from "./OpenQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OpenQuestion.vue?vue&type=style&index=0&id=51911d09&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51911d09",
  null
  
)

export default component.exports